import axios from "axios";

export default function PurchaseorderTerplateDownloadService(orderId) {
  return axios.get(process.env.REACT_APP_API_HOST + "/purchase_order/" + orderId + "/downloadOrderTemplate", {
    responseType: 'blob',
    params: {},
    headers: {'Authorization': 'Bearer ' + localStorage.getItem("userToken"), 'App-Network': localStorage.getItem("networkId")}
  })
};
